import { ISanitizedFilterOutput } from '$models';
import { getFilterParamsFromResult, FILTER_KEY_PAGE } from '../../helpers';

export const useProductResult = (productResults?: ISanitizedFilterOutput[]) => {
    const products = productResults?.map((pr) => pr.products).reduce((a, c) => [...(a || []), ...(c || [])], []);

    // Use last entry for meta data.
    const lastEntry = productResults?.[productResults?.length - 1];

    const total = lastEntry?.totalDocumentsFound;
    const facets = lastEntry?.facets?.map((f) => {
        return {
            ...f,
            isSelected: !!f.facetResults?.some((fr) => fr.isSelected) || f.isSelected,
        };
    });

    const facetSelection = getFilterParamsFromResult(lastEntry);
    facetSelection[FILTER_KEY_PAGE] = [`${lastEntry?.pageIndex}`];
    const sortingOptions = lastEntry?.availableSortOrders;

    return { products, total, facets, facetSelection, sortingOptions, searchTerm: lastEntry?.searchTerm };
};
